var FilterRecurrencesModule = /** @class */ (function () {
    function FilterRecurrencesModule() {
    }
    return FilterRecurrencesModule;
}());
export { FilterRecurrencesModule };
